export default __webpack_public_path__ + "static/media/our mission.a1effb42.svg";